import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import DetailsRightSide from '../../layouts/DetailsRightSide';

interface Props {
  formattedDollarsPrice?: string;
  pointsPrice?: number;
}

const PriceWithPoints: React.FC<Props> = ({ formattedDollarsPrice, pointsPrice }) => {
  return (
    <DetailsRightSide
      firstRow={formattedDollarsPrice}
      secondRow={
        pointsPrice && (
          <>
            <PointsIcon size={IconSize.TINY} disableDefaultColors />
            {pointsPrice}
          </>
        )
      }
    />
  );
};
PriceWithPoints.displayName = 'PriceWithPoints';

export default PriceWithPoints;
